import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { BreadCrumbItem } from './BreadCrumb.Item/BreadCrumb.Item.es.js';

const BreadCrumb = ({ children, className })=>{
    return jsx("nav", {
        className: classNames('cb-breadcrumb', className),
        children: jsx("ol", {
            className: classNames('list'),
            children: children
        })
    });
};
BreadCrumb.displayName = 'BreadCrumb';
BreadCrumb.Item = BreadCrumbItem;

export { BreadCrumb, BreadCrumb as default };
//# sourceMappingURL=BreadCrumb.es.js.map
